<template>
  <page>
    <van-notice-bar
      wrapable
      :scrollable="false"
      text="请上传清晰且四周完整的图片，图片需包含商品名称、规格、价格等"
      style="margin-bottom: 0.32rem"
    />
    <div class="task-tips">
      <div class="tips-title">
        <div class="tips-title-text">上传说明</div>
        <div class="tips-title-btn" @click="goCourse">查看教程</div>
      </div>
      <div class="tips-list">
        <div class="tips-item">1.复制搜索词到app，点击搜索；</div>
        <div class="tips-item">
          2.搜索结果按照<span class="bold">销量排序</span
          >，从上到下依次选取三种商品，拍摄商品<span class="bold">详情页</span
          >图片（<span class="bold">最小规格</span>）；
        </div>
        <div class="tips-item">
          3.完成所有搜索词图片上传后，点击下方提交按钮。
        </div>
      </div>
    </div>
    <div class="search-word-list">
      <task-upload-item
        v-for="item in searchWordList"
        :key="item.taskId"
        :item="item"
        :model.sync="item.picUrl"
        @imgChange="imgChange"
      ></task-upload-item>
      <button class="submit" @click="submit">提交</button>
    </div>

    <van-dialog
      v-model="showSuccess"
      show-cancel-button
      confirm-button-text="立即使用"
      cancel-button-text="我知道了"
      @confirm="toUse"
      @cancel="toTaskList"
    >
      <div class="success">
        <div class="title">优惠券已发放，</div>
        <div class="title">可前往个人中心查看或立即使用！</div>
        <div class="text">（如未及时到账，优惠券将在5分钟内发放）</div>
      </div>
    </van-dialog>
  </page>
</template>

<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import taskUploadItem from './components/taskUploadItem'
import { API } from '@/api'
import { companyId, cityId, deviceToken } from '@/defines/user'
import { Dialog } from 'vant'

export default {
  name: 'TaskDetail',
  components: { taskUploadItem },
  provide() {
    return {
      ossData: this.ossData,
      showImg: this.showImg
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.query = {
        beginTime: Number(to.query.beginTime),
        endTime: Number(to.query.endTime),
        configId: Number(to.query.configId)
      }
      vm.getDetail(vm.query)
      navBar.setTitle({
        text: '任务明细'
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.hevueImgPreview) {
      this.hevueImgPreview.close()
    }
    next()
  },
  data() {
    return {
      showSuccess: false,
      searchWordList: [],
      query: {},
      ossData: {
        ossData: {}
      },
      hevueImgPreview: null
    }
  },
  created() {
    API.newReqGood
      .getOssKey({
        source_key: 'mall-entrance'
      })
      .then(res => {
        this.ossData.ossData = res
      })
    this.deleteExpireStorage()
  },
  methods: {
    async submit(query) {
      const type = this.searchWordList.every(item => {
        return item.picUrl.length === 3
      })
      if (type) {
        try {
          const res = await API.marketResearch.submitTask({
            deviceToken,
            companyId,
            cityId,
            task: this.searchWordList.map(item => {
              return {
                taskId: item.taskId,
                picUrl: item.picUrl
              }
            }),
            ...this.query
          })
          if (res.status === 1) {
            this.showSuccess = true
          } else {
            this.$toast('提交失败')
          }
        } catch (error) {
          this.$toast(error.res.msg)
          this.$router.back()
        }
      } else {
        Dialog({
          message: '存在未上传图片，请确保所有图片上传完成后再进行提交'
        })
      }
    },
    async getDetail(query) {
      try {
        const res = await API.marketResearch.getTaskDetail({
          deviceToken,
          companyId,
          configId: query.configId,
          beginTime: query.beginTime,
          endTime: query.endTime,
          cityId
        })
        this.searchWordList = res.map(item => {
          return {
            ...item,
            picUrl: []
          }
        })
        this.setUploadImgs()
      } catch (error) {
        console.log(error)
      }
    },
    toUse() {
      this.$nativeRedirect(this.$nativeRoutes.myCoupons)
      setTimeout(() => {
        this.$router.back()
      }, 1000)
    },
    toTaskList() {
      this.$router.back()
    },
    imgChange() {
      /**
       {
          configId: '',
          beginTime: '',
          endTime: '',
          taskList: this.searchWordList
       }
       */
      // 判断 localStorage 中有没有当前configId的记录，有的话替换，没有push
      const uploadImgs = JSON.parse(localStorage.getItem('uploadImgs') || '[]')
      const index = uploadImgs.findIndex(
        item => item.configId === this.query.configId
      )
      const newDetail = {
        ...this.query,
        taskList: this.searchWordList
      }
      if (index > -1) {
        uploadImgs[index] = newDetail
      } else {
        uploadImgs.push(newDetail)
      }
      localStorage.setItem('uploadImgs', JSON.stringify(uploadImgs))
    },
    setUploadImgs() {
      // 判断 loaclStorage 中是否有数据，有的话回显
      const uploadImgs = JSON.parse(localStorage.getItem('uploadImgs') || '[]')
      const localItem = uploadImgs.find(
        item => item.configId === this.query.configId
      )
      if (localItem) {
        this.searchWordList.forEach(item => {
          const taskItem = localItem.taskList.find(
            task => task.taskId === item.taskId
          )
          item.picUrl = taskItem?.picUrl
        })
      }
    },
    // 删除过期的存储
    deleteExpireStorage() {
      const uploadImgs = JSON.parse(localStorage.getItem('uploadImgs') || '[]')
      const newUploadImgs = uploadImgs.filter(
        item => item.endTime > new Date().getTime() / 1000
      )
      localStorage.setItem('uploadImgs', JSON.stringify(newUploadImgs))
    },
    goCourse() {
      location.href = 'https://material-page.yunshanmeicai.com/richText/1001101'
    },
    // 上传图片的查看
    showImg(img) {
      this.hevueImgPreview = this.$hevueImgPreview(img)
    }
  }
}
</script>

<style lang="scss" scoped>
.task-tips {
  width: 7.02rem;
  height: 3rem;
  background: #f5f5f5;
  border-radius: 0.16rem;
  padding: 0.24rem 0.24rem 0;
  margin: 0 auto 0.32rem;
  .bold {
    font-weight: 600;
    padding: 0 0.04rem;
  }
  .tips-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.16rem;
    .tips-title-text {
      font-weight: 600;
      font-size: 0.32rem;
      color: #262626;
    }
    .tips-title-btn {
      font-size: 0.28rem;
      color: #55a6eb;
    }
  }
  .tips-list {
    font-weight: 400;
    font-size: 0.28rem;
    color: #595959;
    line-height: 0.48rem;
  }
}
.search-word-list {
  height: calc(100vh - 4.96rem);
  overflow-y: auto;
}
.submit {
  display: block;
  width: 6.5rem;
  height: 0.88rem;
  background: #15bb5c;
  border-radius: 0.8rem;
  text-align: center;
  line-height: 0.88rem;
  color: #fff;
  margin: 1.58rem auto 0.54rem;
}
.success {
  text-align: center;
  padding: 0.6rem 0;
  .title {
    font-size: 0.34rem;
    line-height: 1.5em;
    font-weight: 600;
  }
  .text {
    font-size: 0.28rem;
    font-weight: 400;
    color: #999;
    margin-top: 0.1rem;
  }
}
</style>
